/**
 * notifications.js — Helpers pour declencher des toasts globaux.
 *
 * Utilisation :
 *   import { notifySuccess, notifyError, notifyInfo, notifyWarning } from '../utils/notifications';
 *
 *   notifySuccess('Vente VTE-2026-0042 enregistree');
 *   notifyError('Impossible de sauvegarder', { code: 'E-3AF9B2' });
 *
 * Sous le capot : window.dispatchEvent CustomEvent('erp:notification').
 * Composant Toast.js (mounted dans Layout) ecoute et affiche.
 */

const dispatch = (level, message, options = {}) => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent('erp:notification', {
    detail: {
      level,
      message,
      code: options.code || null,
      status: options.status || null,
      duration: options.duration || null,
    },
  }));
};

export const notifySuccess = (message, options = {}) => {
  dispatch('success', message, { duration: 2500, ...options });
};

export const notifyError = (message, options = {}) => {
  dispatch('error', message, { duration: 5000, ...options });
  // Compat ancien ErrorToast
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('erp:error', {
      detail: {
        message,
        code: options.code || null,
        status: options.status || null,
      },
    }));
  }
};

export const notifyInfo = (message, options = {}) => {
  dispatch('info', message, { duration: 3000, ...options });
};

export const notifyWarning = (message, options = {}) => {
  dispatch('warning', message, { duration: 4000, ...options });
};

export const handleApiResponse = (response, fallbackSuccess = 'Action effectuee') => {
  const msg = response?.data?.message || fallbackSuccess;
  notifySuccess(msg);
  return response;
};

export const handleApiError = (error, fallbackError = 'Erreur inattendue') => {
  const data = error?.response?.data || {};
  const msg = data.error || data.message || error?.message || fallbackError;
  notifyError(msg, { code: data.code, status: error?.response?.status });
  return Promise.reject(error);
};
